// Значення в .copy-elem тепер може містити розмітку (жирний шрифт, <br>
// у довгому IBAN). main.js на цьому місці працює виключно текстом:
//
//   box.originalText ||= elem.textContent      // запам'ятав
//   elem.textContent = 'Скопійовано'           // підмінив
//   setTimeout(() => elem.textContent = box.originalText)   // повернув
//
// Тобто перший же клік по кнопці розкладає розмітку в плаский рядок — і так
// до перезавантаження сторінки. Правити main.js не можна (збілджений код
// верстки, §7.5 docs/css.md), тож повертаємо розмітку самі.
//
// Слухати клік недостатньо: тривалість таймера в main.js нам невідома, і
// гонитва двох таймерів вийшла б крихкою. Тому дивимось за самим вузлом —
// щойно main.js закінчив анімацію (клас .is-copy знято), а вміст не збігся з
// вихідним, ставимо innerHTML назад.
//
// Іде ПІСЛЯ main.js, як решта хелперів; для порядку це не критично —
// innerHTML знімається до першого кліку в будь-якому разі.
document.querySelectorAll('.copy-box').forEach((box) => {
  const elem = box.querySelector('.copy-elem');

  // Плаский текст main.js і сам поверне правильно — спостерігати нема за чим.
  // Це ж і тримає вартість на нулі для всіх наявних реквізитів без розмітки.
  if (!elem || elem.children.length === 0) {
    return;
  }

  const html = elem.innerHTML;

  const observer = new MutationObserver(() => {
    // .is-copy — стан «Скопійовано»: там текст підмінений навмисно.
    if (box.classList.contains('is-copy') || elem.innerHTML === html) {
      return;
    }

    // Власна ж мутація прийде наступним викликом і відсіється рядком вище:
    // innerHTML уже дорівнюватиме вихідному. Тому окремого прапорця не треба.
    elem.innerHTML = html;
  });

  observer.observe(elem, { childList: true, characterData: true, subtree: true });
});
